import {Component, Inject, PLATFORM_ID} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {CustomDatePipe, CustomMessageService, UtilService, LocalStorageService} from "library";
import {CategoryRequestService} from "../../../../../services/api/v1/category-request.service";
import {UserValidatorService} from "../../../../../services/api/v1/user-validator.service";
import {RequestService} from "../../../../../services/api/v1/request.service";
import {PixelService} from "../../../../../services/api/v1/pixel.service";
import {SalesSimulatorKredicashEmbeddedComponent} from "../sales-simulator-kredicash-embedded.component";

/**
 * Componente de Simulador Kredicash Embebido (Tema V2)
 * Hereda toda la lógica del componente principal
 */
@Component({
  selector: 'app-sales-simulator-kredicash-embedded-v2',
  templateUrl: './sales-simulator-kredicash-embedded-v2.component.html',
  providers: [CustomDatePipe]
})
export class SalesSimulatorKredicashEmbeddedV2Component extends SalesSimulatorKredicashEmbeddedComponent {

  constructor(
    protected override categoryRequestService: CategoryRequestService,
    protected override utilService: UtilService,
    protected override customMessageService: CustomMessageService,
    protected override customDatePipe: CustomDatePipe,
    protected override userValidatorService: UserValidatorService,
    protected override requestService: RequestService,
    protected override localStorageService: LocalStorageService,
    protected override metaPixelService: PixelService,
    protected override route: ActivatedRoute,
    protected override router: Router,
    @Inject(PLATFORM_ID) protected override platformId: Object
  ) {
    super(
      categoryRequestService,
      utilService,
      customMessageService,
      customDatePipe,
      userValidatorService,
      requestService,
      localStorageService,
      metaPixelService,
      route,
      router,
      platformId
    );
  }
}

/**
 * Componente de Simulador Kredicash Embebido (Tema V3)
 * Hereda toda la lógica del componente principal
 */
@Component({
  selector: 'app-sales-simulator-kredicash-embedded-v3',
  templateUrl: './sales-simulator-kredicash-embedded-v3.component.html',
  providers: [CustomDatePipe]
})
export class SalesSimulatorKredicashEmbeddedV3Component extends SalesSimulatorKredicashEmbeddedComponent {

  constructor(
    protected override categoryRequestService: CategoryRequestService,
    protected override utilService: UtilService,
    protected override customMessageService: CustomMessageService,
    protected override customDatePipe: CustomDatePipe,
    protected override userValidatorService: UserValidatorService,
    protected override requestService: RequestService,
    protected override localStorageService: LocalStorageService,
    protected override metaPixelService: PixelService,
    protected override route: ActivatedRoute,
    protected override router: Router,
    @Inject(PLATFORM_ID) protected override platformId: Object
  ) {
    super(
      categoryRequestService,
      utilService,
      customMessageService,
      customDatePipe,
      userValidatorService,
      requestService,
      localStorageService,
      metaPixelService,
      route,
      router,
      platformId
    );
  }
}
